import { render, staticRenderFns } from "./switchLayer.vue?vue&type=template&id=0cbc4177&scoped=true&"
import script from "./switchLayer.vue?vue&type=script&lang=js&"
export * from "./switchLayer.vue?vue&type=script&lang=js&"
import style0 from "./switchLayer.vue?vue&type=style&index=0&id=0cbc4177&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc4177",
  null
  
)

export default component.exports